import React from "react";
import axios from "axios";
import moment from "moment";
import ReactTooltip from "react-tooltip";

import StudentsIndexlinks from "./indexLinks";
import { hasStaffRole } from "../../utils/auth";

export default class StudentsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            email_verified: false,
            email_sent_again: false
        };
    }

    resendConfirmationMail = () => {
        axios
            .post("/v1/auth/reset-password/", {
                email: this.state.email
            })
            .then((response) => {
                this.setState({
                    email_sent_again: true
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).catch((err) => {
            console.error("Failed to copy text: ", err);
        });
    };

    componentDidMount() {
        axios
            .get("/v1/students/" + this.props.params.itemID + "/")
            .then((response) => {
                this.setState({
                    loaded: true,
                    ...response.data
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        let resultHTML = null;
        let userRoles = this.props.authentication?.user?.roles;

        if (this.state.loaded) {
            resultHTML = (
                <div className="row">
                    <div className="col-4">
                        <div className="copy-button-container">
                            <h2>NIBHV-nummer</h2>
                            <i
                                onClick={() => this.copyToClipboard(this.state.nibhv_number)}
                                className="fa fa-copy copy-button"
                                data-tip
                                data-for="tip-copy-nibhv-number"
                            />
                            <ReactTooltip id="tip-copy-nibhv-number" effect="solid" place="right">
                                Kopieer NIBHV-nummer naar klembord.
                            </ReactTooltip>
                        </div>
                        <p>{this.state.nibhv_number}</p>

                        <h2>Voorletters</h2>
                        <p>{this.state.initials || "-"}</p>
                    </div>
                    <div className="col-4">
                        <h2>Taal</h2>
                        <p>
                            {this.state.language === "nl" ? "Nederlands" : false}
                            {this.state.language === "en" ? "Engels" : false}
                        </p>

                        <h2>Geboortedatum</h2>
                        <p>{this.state.date_of_birth !== null ? moment(this.state.date_of_birth).format("DD-MM-YYYY") : "Nog niet ingevuld"}</p>

                        {this.state?.email && (
                            <>
                                <div className="copy-button-container">
                                    <h2>E-mail adres</h2>
                                    <i onClick={() => this.copyToClipboard(this.state.email)} className="fa fa-copy copy-button" data-tip data-for="tip-copy-email" />
                                    <ReactTooltip id="tip-copy-email" effect="solid" place="right">
                                        Kopieer e-mail adres naar klembord.
                                    </ReactTooltip>
                                </div>
                                <p>
                                    <a href={`mailto:${this.state.email}`}>{this.state.email}</a>{" "}
                                    {this.state.email_verified && <i className="fa fa-check" title="Geverifieerd"></i>}
                                </p>
                                {!this.state.email_verified && !this.state.email_sent_again && (
                                    <p>
                                        <span className="btn btn-secondary" onClick={() => this.resendConfirmationMail()}>
                                            Stuur nogmaals uitnodigingsmail
                                        </span>
                                    </p>
                                )}
                                {this.state.email_sent_again && <p>De bevestigingsmail is opnieuw verstuurd.</p>}
                            </>
                        )}
                    </div>
                    <div className="col-4">
                        <h2>Actief</h2>
                        <p>{this.state.is_active ? "Ja" : "Nee"}</p>

                        <h2>Instructeur</h2>
                        <p>{this.state.is_instructor ? "Ja " : "Nee"}</p>
                        {hasStaffRole(userRoles) && this.state.is_instructor ? (
                            <a href={`/instructors/edit/${this.state.uuid}`} className="btn btn-secondary">
                                Bewerk instructeur gegevens
                            </a>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            );
        }

        return (
            <div>
                <StudentsIndexlinks
                    title={this.state.full_name}
                    nibhv_number={this.state.nibhv_number}
                    studentUUID={this.props.params.itemID}
                    buttons={[{ title: "Cursist bewerken", link: "/students/edit/" + this.props.params.itemID, classname: "btn btn-primary" }]}
                />

                {resultHTML || <h2>Ophalen van gegevens...</h2>}
            </div>
        );
    }
}
